export const DESKTOP_COLORS = {
    BACKGROUND_GREY: '#f2f2f2',
    TEXT_PRIMARY: '#2A3234',
    TEXT_SECONDARY: '#6D7278',
    LOCATIONS_BACKGROUND: '#f7f9fb'
};
